module.exports = __webpack_public_path__ + "img/eye.76cc45c2.svg";